import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductionSlideshow from './components/ProductionSlideshow';
import WhyUs from './components/WhyUs';
import TechnologySection from './components/TechnologySection';
import PricingTable from './components/PricingTable';
import PartnershipForm from './components/PartnershipForm';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <ProductionSlideshow />
          <WhyUs />
          <TechnologySection />
          <PricingTable />
          <PartnershipForm />
        </main>
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
